var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 10.4167C20.1433 10.4167 19.5833 9.85667 19.5833 9.16667V0.416667C19.5833 0.186667 19.3967 0 19.1667 0H5C2.23833 0 0 2.23833 0 5V35C0 37.7617 2.23833 40 5 40H25C27.7617 40 30 37.7617 30 35V10.8333C30 10.6033 29.8133 10.4167 29.5833 10.4167H20.8333Z",
    fill: "#00535C",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 29.334H5.9375V22.1953H9.9707V23.1816H7.09961V25.4082H9.78516V26.3896H7.09961V29.334ZM11.2695 29.334V22.1953H12.4414V29.334H11.2695ZM14.3262 29.334V22.1953H15.498V28.3379H18.5303V29.334H14.3262ZM23.8086 29.334H19.7656V22.1953H23.8086V23.1816H20.9375V25.1201H23.6279V26.1016H20.9375V28.3428H23.8086V29.334Z",
    fill: "#00535C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0834 1.56629V7.49996C22.0834 7.72995 22.27 7.9166 22.5 7.9166H28.4337C28.8045 7.9166 28.9911 7.46747 28.7287 7.20499L22.795 1.27131C22.5325 1.00883 22.0834 1.19465 22.0834 1.56629Z",
    fill: "#00535C",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.efc0c2305d24d02080b04b3b6bcdc2b1.svg";
export { ForwardRef as ReactComponent };